




























































































































































































































































































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  QueryScreeningResult,
  PushPatientBatch,
  ExportManagedPatients,
} from "@/api/pdReferral";
import { GetListByCode } from "@/api/configureDictionary";
import { GetCommunityAll } from "@/api/pdCommunity/index";
import SetTeam from "@/views/pdReferral/pdScreening/setTeam.vue";
import SetDoctor from "@/views/pdReferral/pdScreening/setDoctor.vue";
import PdPushPatientBatch from "@/views/pdReferral/pdScreening/pushBatch.vue";
import { GetAllTown } from "@/api/pdOutPatient/pdCity";
import PdPushPatient from "@/views/pdReferral/pdScreening/push.vue";
import PdChartAssayTrend from "@/views/electronicMedicalRecord/patient/parts/assayResult/detailed.vue";
import FileSaver from "file-saver";
import { GetAllResponsibleNurse, GetAllResponsibleDoctor } from "@/api/pdTeam";
import PdDistributePushPatient from "@/views/pdReferral/pdScreening/distribute.vue";
import ajax from "axios";
import util from "@/lib/util";
import FollowCardDetail from "@/views/followCard/parts/detail.vue";
import { GetPrimaryDiagItemAll } from "@/api/electronicMedicalRecord";
import FollowFormForSql from "@/views/follow/followForm/followFormForSql.vue";
import patientInfo from "./parts/patientInfo.vue";

@Component({
  components: {
    patientInfo,
    SetTeam,
    SetDoctor,
    PdPushPatient,
    PdPushPatientBatch,
    PdChartAssayTrend,
    PdDistributePushPatient,
    FollowCardDetail,
    FollowFormForSql,
  },
})
export default class extends AbpBase {
  dates: any = [];
  data: any = [];
  tableTotalSize: number = 0;
  totalCount: number = 0;
  tabCount: string = "所有患者";
  tabCount1: string = "本人";
  tabCount2: string = "本团队";
  tabCount3: string = "本院";
  tabCount4: string = "关注患者";
  totalCount1: number = 0;
  totalCount2: number = 0;
  totalCount3: number = 0;
  totalCount4: number = 0;
  loading: boolean = false;
  showCondition: boolean = false;
  showPatientDetail: boolean = false;
  showPush: boolean = false;
  showPushBatch: boolean = false;
  currentPatient: any = {};
  communityList: any[] = [];
  townList: any[] = [];
  villageList: any[] = [];
  cityList: any[] = [];
  showCentralHospital: boolean = false;
  selectedTab: string = "tabMySelf";
  showTeam: boolean = false;
  showDoctor: boolean = false;
  showAdd: boolean = false; //新增患者页面
  chartData: any = {};
  showChartAssay: boolean = false;
  detailTitle: string = "";
  showDistribute: boolean = false;
  showDetail: boolean = false;
  showFollowFormForSql: boolean = false;
  currentFollow: any = {};
  AllDoctorList: any[] = [];
  AllNurseList: any[] = [];
  AllDiagItem: any[] = []; // 原发病诊断代码表
  columns = [];
  columnsData = [
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      key: "pick",
    },
    {
      title: "姓名",
      width: 100,
      fixed: "left",
      key: "name",
    },
    {
      title: "身份证号",
      width: 200,
      key: "cid",
    },
    {
      title: "医保卡号",
      width: 180,
      key: "patientCard",
    },
    {
      title: "性别",
      width: 80,
      key: "sexName",
    },
    {
      title: "出生日期",
      width: 120,
      key: "birthday",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.birthday));
      },
    },
    {
      title: "年龄",
      width: 80,
      key: "age",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.age + "岁");
      },
    },
    {
      title: "诊断",
      width: 300,
      key: "diagnose",
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        let diagnose = "";
        if (p.row.diagnose) diagnose = p.row.diagnose.substr(0, 16);
        return h(
          "Tooltip",
          {
            props: {
              placement: "bottom",
              content: p.row.diagnose,
              "max-width": 400,
              transfer: true,
            },
          },
          diagnose
        );
      },
    },
    {
      title: "患者标签",
      width: 80,
      key: "patientTag",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.patientTag );
      },
    },
    {
      title: "尿白蛋白",
      width: 120,
      key: "urineProtein",
    },
    {
      title: "血白蛋白",
      width: 140,
      key: "bloodAlbumin",
      render: (h: any, p: any) => {
        if (p.row.bloodAlbumin != null) {
          return h("div", [
            h("span", p.row.bloodAlbumin),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "5431",
                    itemName: "血白蛋白",
                    unit: "/uL",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "肌酐",
      width: 140,
      key: "crea",
      render: (h: any, p: any) => {
        if (p.row.crea != null) {
          return h("div", [
            h("span", p.row.crea),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "5929",
                    itemName: "肌酐",

                    unit: "mg/g",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "尿酸",
      width: 140,
      key: "urineacid",
      render: (h: any, p: any) => {
        if (p.row.urineacid != null) {
          return h("div", [
            h("span", p.row.urineacid),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "600092",
                    itemName: "尿酸",
                    unit: "/uL",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "eGFR",
      width: 140,
      key: "ckdEpi",
      render: (h: any, p: any) => {
        if (p.row.ckdEpi != null) {
          return h("div", [
            h("span", p.row.ckdEpi),
            h("Icon", {
              props: {
                type: "ios-podium",
                size: "20",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  let r = {
                    pD_Patient_ID: p.row.id,
                    itemCode: "1113",
                    itemName: "eGFR",
                    unit: "",
                  };
                  this.showChart(r);
                },
              },
            }),
          ]);
        }
      },
    },
    {
      title: "CKD分期",
      width: 110,
      key: "ckd",
      render: (h: any, p: any) => {
        if (p.row.ckd) {
          let props: any = {};
          switch (p.row.ckd) {
            case "G1":
              props.color = "blue";
              break;
            case "G2":
              props.color = "cyan";
              break;
            case "G3a":
              props.color = "red";
              break;
            case "G3b":
              props.color = "#FFA2D3";
              break;
            case "G4":
              props.color = "warning";
              break;
            case "G5":
              props.color = "error";
              break;
          }
          return h("Tag", { props: props }, p.row.ckd + " 期");
        }
      },
    },
    {
      title: "钾离子",
      width: 120,
      key: "k",
    },
    {
      title: "建议随访次数",
      width: 150,
      key: "followTimes",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.followTimes + "次/年");
      },
    },
    {
      title: "已随访次数",
      width: 150,
      key: "followCount",
      render: (h: any, p: any) => {
        if (p.row.followCount) {
          return h("span", {}, p.row.followCount + "次");
        }
      },
    },
    {
      title: "最近一次随访",
      width: 150,
      key: "followTime",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.followTime));
      },
    },
    {
      title: "下次随访",
      width: 150,
      key: "nextFollowTime",
      render: (h: any, p: any) => {
        let props: any = {};
        let today = this.formatDate(new Date());
        let next = this.formatDate(p.row.nextFollowTime);
        if (today >= next) {
          //到期未随访
          props.style = { color: "red" };
        }
        return h("span", props, this.formatDate(p.row.nextFollowTime));
      },
    },
    {
      title: "所属社区",
      minWidth: 140,
      tooltip: true,
      ellipse: true,
      key: "communityName",
    },
    {
      title: "所属团队",
      minWidth: 120,
      tooltip: true,
      key: "teamName",
    },
    {
      title: "所属医生",
      width: 120,
      tooltip: true,
      key: "doctorName",
    },
    {
      title: "入组时间",
      width: 120,
      key: "joinTime",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.joinTime));
      },
    },
    {
      title: "肾移植病史",
      width: 120,
      key: "kidneyDate",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.kidneyDate));
      },
    },
    {
      title: "街道/乡镇",
      width: 120,
      key: "addr_TownName",
    },
    {
      title: "小区/村",
      width: 150,
      tooltip: true,
      ellipse: true,
      key: "addr_VillageName",
    },
    {
      key: "caozuo",
      width: 300,
      fixed: "right",
      title: "操作",
      render: (h: any, p: any) => {
        let buttons = [
          h(
            "Button",
            {
              props: { type: "primary", size: "small" },
              style: { marginRight: "10px" },
              on: {
                click: () => {
                  this.basicInfo(p.row);
                },
              },
            },
            "查看"
          ),
        ];
        buttons.push(
          h(
            "Button",
            {
              props: { type: "info", size: "small" },
              style: { marginRight: "10px" },
              on: {
                click: () => {
                  this.handleAddFollowCard(p.row);
                },
              },
            },
            "随访"
          )
        );
        if (p.row.communityName == "兴安盟人民医院") {
          buttons.push(
            h(
              "Button",
              {
                props: { type: "error", size: "small" },
                on: {
                  click: () => {
                    this.handlePush(p.row);
                  },
                },
              },
              "下推"
            )
          );
        } else {
          buttons.push(
            h(
              "Button",
              {
                props: { type: "error", size: "small" },
                style: { marginRight: "10px" },
                on: {
                  click: () => {
                    this.handlePush(p.row);
                  },
                },
              },
              "上推"
            )
          );
          if (!p.row.teamId) {
            buttons.push(
              h(
                "Button",
                {
                  props: { type: "info", size: "small" },
                  on: {
                    click: () => {
                      this.handleSetTeam(p.row);
                    },
                  },
                },
                "分配团队"
              )
            );
          }
          if (p.row.teamId && !p.row.doctor) {
            buttons.push(
              h(
                "Button",
                {
                  props: { type: "success", size: "small" },
                  on: {
                    click: () => {
                      this.handleSetDoctor(p.row);
                    },
                  },
                },
                "分配医生"
              )
            );
          }
          if (p.row.teamId && p.row.doctor) {
            buttons.push(
              h(
                "Button",
                {
                  props: { type: "success", size: "small" },
                  on: {
                    click: () => {
                      this.distribute(p.row);
                    },
                  },
                },
                "分配"
              )
            );
          }
        }

        if (this.PatientListHISButonShow) {
          buttons.push(
            h(
              "Button",
              {
                props: { type: "info", size: "small" },
                style: { marginLeft: "10px" },
                on: {
                  click: () => {
                    this.showEmr(p.row);
                  },
                },
              },
              this.PatientListHISNameChange
            )
          );
        }
        return h("div", buttons);
      },
    },
    {
      title: "接听状态",
      width: 120,
      key: "answerStatusStr",
    },
  ];
  get PatientListHISButonShow() {
    return util.abp.setting.get("PatientListHISButonShow") == "1";
  }

  get PatientListHISNameChange() {
    return util.abp.setting.get("PatientListHISNameChange");
  }

  get PatientListHISType() {
    return util.abp.setting.get("PatientListHISType");
  }
  get followUpUserSql() {
    return util.abp.setting.get("followUpUserSql") == "1";
  }

  // 显示His电子病历视图
  showEmr(row: any) {
    let url = `${SYNC_EMR_URL}?patientId=${row.id}&userCode=${this.$store.state.session.user.userName}`;
    ajax
      .get(url, { timeout: 60000 })
      .then((res: any) => {
        this.$Loading.finish();
        if (res.data.code === 2000) {
          switch (this.PatientListHISType) {
            case "0":
              let emrUrl = res.data.data;
              window.open(emrUrl);
              break;
            case "1":
              this.openExe(res.data.data);
              break;
          }
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.$Loading.error();
        this.$Modal.error({
          title: "提示",
          content: "读取患者电子病历视图地址时出现错误",
        });
      });
  }

  // 打开本地客户端上的exe程序
  // 使用说明见源码目录openExe目录下
  openExe(paras: string) {
    try {
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = `openExe:${paras}`;
      console.log(a.href);
      a.click();
    } catch (error) {
      console.log(error);
      alert("客户端程序打开异常，请联系工程师处理。");
    }
  }

  async renderColumns() {
    this.columns = await this.$store.dispatch("columnSettings/renderColumns", {
      moduleName: "患者管理患者信息",
      columnsData: this.columnsData,
    });
  }

  //基本信息
  basicInfo(row: any) {
    this.detailTitle = `患者明细（${row.name}）`;
    this.currentPatient = row;
    this.currentPatient.pD_Patient_ID = row.id;
    this.showPatientDetail = true;
  }

  styles = {
    height: "calc(100% - 55px)",
    overflow: "auto",
    paddingBottom: "53px",
    position: "static",
  };

  queryConditionnull: any = {
    page: 1,
    pageSize: 10,
    name: "",
    sexName: "",
    birthday: null,
    ageStart: null,
    ageEnd: null,
    cid: "",
    address: "",
    patientCard: "",
    ckdEpiStart: null,
    ckdEpiEnd: null,
    communityId: null,
    ckd: null,
    k: null,
    category: 1,
    state: "-1",
    followState: "-1",
    addr_Town: null,
    addr_Village: null,
    urineProtein: null,
    rbcStart: null,
    rbcEnd: null,
    acrStart: null,
    acrEnd: null,
    screeningType: "",
    isOutcome: "0",
  };
  //查询条件
  queryCondition: any = {
    page: 1,
    pageSize: 10,
    name: "",
    sexName: "",
    birthday: null,
    ageStart: null,
    ageEnd: null,
    cid: "",
    address: "",
    patientCard: "",
    ckdEpiStart: null,
    ckdEpiEnd: null,
    communityId: null,
    ckd: null,
    category: 1,
    state: "-1",
    followState: "-1",
    addr_Town: null,
    addr_Village: null,
    urineProtein: null,
    rbcStart: null,
    rbcEnd: null,
    acrStart: null,
    acrEnd: null,
    kStart: null,
    kEnd: null,
    screeningType: "",
    isOutcome: "0",
    IsPathologyPatient: true,
  };

  created() {
    this.renderColumns();
    this.initDic();
    let user = this.$store.state.session.user;
    if (user) {
      this.showCentralHospital = user.communityName == "兴安盟人民医院";
      if (this.showCentralHospital) {
        this.selectedTab = "tabAll";
      } else {
        this.selectedTab = "tabMySelf";
      }
    }
  }
  async handleDetailSubmit() {
    let res = await this.$refs.FollowCardDetail.submit();
    if (res) {
      this.showDetail = false;
      this.getData();
    }
  }
  async handleAddFollowCard(row: any) {
    console.log(row);
    if (this.followUpUserSql) {
      this.showFollowFormForSql = true;
      this.currentFollow = row;
    } else {
      this.currentFollow = { patientId: row.id };
      this.showDetail = true;
    }
  }
  async initDic() {
    let res = await GetCommunityAll();
    this.communityList = res.objects;
    if (this.communityList.length != 0) {
      this.queryCondition.communityId = this.communityList[0].id;
    }
    this.getData();

    let resCity = await GetAllTown();
    this.cityList = resCity.objects;
    if (this.cityList && this.cityList.length > 0) {
      this.townList = this.cityList.filter((x) => x.parentCode == "");
    }

    let resNurseList = await GetAllResponsibleNurse();
    this.AllNurseList = resNurseList.data;
    let resDoctorList = await GetAllResponsibleDoctor();
    this.AllDoctorList = resDoctorList.data;
    let resDiagItemList = await GetPrimaryDiagItemAll();
    this.AllDiagItem = resDiagItemList.objects;
  }

  pageChange(val: any) {
    this.queryCondition.Page = val;
    this.getData();
  }

  handleQuery() {
    this.showCondition = true;
  }

  //批量推送
  handlePushBatch(tableName: string) {
    let patList = (this.$refs[tableName] as any).getSelection();
    if (patList.length == 0) {
      this.$Message.error("请勾选要推送的患者");
      return;
    }
    this.showPushBatch = true;
  }

  async handlePushBatchSubmit() {
    let res = await this.$refs.PdPushPatientBatch.submit();
    if (res.targetCommunityId) {
      this.showPushBatch = false;
      //提交推送数据
      let patList = this.$refs.table1.getSelection();
      res.PatientList = patList;
      await PushPatientBatch(res);
    }
  }

  handleResetCondition() {
    this.queryCondition.name = "";
    this.queryCondition.sexName = "";
    this.queryCondition.cid = "";
    this.queryCondition.address = "";
    this.queryCondition.patientCard = "";
    this.queryCondition.ckd = null;
    this.queryCondition.ckdEpiStart = null;
    this.queryCondition.ckdEpiEnd = null;
    this.queryCondition.state = "-1";
    this.queryCondition.followState = "-1";
    this.queryCondition.addr_Town = null;
    this.queryCondition.addr_Village = null;
    this.queryCondition.ageStart = null;
    this.queryCondition.ageEnd = null;
    this.queryCondition.urineProtein = null;
    this.queryCondition.rbcStart = null;
    this.queryCondition.rbcEnd = null;
    this.queryCondition.KStart = null;
    this.queryCondition.KEnd = null;
    this.queryCondition.acrStart = null;
    this.queryCondition.acrEnd = null;
    this.queryCondition.screeningType = "";
    this.queryCondition.responsibleDoctor = "";
    this.queryCondition.responsibleNurse = "";
  }

  handleScreening() {
    this.showCondition = false;
    this.queryCondition.Page = 1;
    this.$nextTick(() => {
      this.$refs["pages"].currentPage = 1;
    });
    this.getData();
  }

  //分配团队
  handleSetTeam(row: any) {
    this.currentPatient = row;
    this.showTeam = true;
  }

  //分配医生
  handleSetDoctor(row: any) {
    this.currentPatient = row;
    this.showDoctor = true;
  }

  async getData() {
    if (this.selectedTab == "tabAll") {
      this.queryCondition.category = 0;
    } else {
      let user = this.$store.state.session.user;
      if (!user) {
        this.queryCondition.communityId = -1;
      } else {
        this.queryCondition.communityId = user.communityId;
      }
      if (this.selectedTab == "tabMyHos") {
        this.queryCondition.category = 1;
      } else if (this.selectedTab == "tabMyTeam") {
        this.queryCondition.category = 2;
      } else if (this.selectedTab == "tabMySelf") {
        this.queryCondition.category = 3;
      } else if (this.selectedTab == "tabAttention") {
        this.queryCondition.category = 4;
      }
    }
    if (this.queryCondition.communityId) {
      this.loading = true;
      let payload = Object.assign({}, this.queryCondition);
      if (this.queryCondition.diagnose)
        payload.diagnose = this.queryCondition.diagnose.join(",");
      let res = await QueryScreeningResult(payload);

      this.data = res.items;
      this.columnsData = this.data;
      if (this.selectedTab == "tabAll") {
        this.totalCount = res.totalCount;
        this.tabCount = "所有患者(" + this.totalCount + ")";
        this.tabCount3 = "本院";
        this.tabCount2 = "本团队";
        this.tabCount1 = "本人";
        this.tabCount4 = "关注患者";
      } else {
        if (this.selectedTab == "tabMyHos") {
          this.totalCount3 = res.totalCount;
          this.tabCount3 = "本院(" + this.totalCount3 + ")";
          this.tabCount = "所有患者";
          this.tabCount2 = "本团队";
          this.tabCount1 = "本人";
          this.tabCount4 = "关注患者";
        } else if (this.selectedTab == "tabMyTeam") {
          this.totalCount2 = res.totalCount;
          this.tabCount2 = "本团队(" + this.totalCount2 + ")";
          this.tabCount3 = "本院";
          this.tabCount = "所有患者";
          this.tabCount1 = "本人";
          this.tabCount4 = "关注患者";
        } else if (this.selectedTab == "tabMySelf") {
          this.totalCount1 = res.totalCount;
          this.tabCount1 = "本人(" + this.totalCount1 + ")";
          this.tabCount3 = "本院";
          this.tabCount2 = "本团队";
          this.tabCount = "所有患者";
          this.tabCount4 = "关注患者";
        } else if (this.selectedTab == "tabAttention") {
          this.totalCount4 = res.totalCount;
          this.tabCount4 = "关注患者(" + this.totalCount4 + ")";
          this.tabCount3 = "本院";
          this.tabCount2 = "本团队";
          this.tabCount1 = "本人";
          this.tabCount = "所有患者";
        }
      }
      this.tableTotalSize = res.totalCount;
      this.loading = false;
    }
  }

  //推送
  handlePush(row: any) {
    this.currentPatient = row;
    this.showPush = true;
  }
  //分配
  distribute(row: any) {
    this.currentPatient = row;
    this.showDistribute = true;
  }
  //保存推送数据
  handlePushSubmit() {
    this.$refs["PdPushPatient"].submit().then((res) => {
      this.showPush = false;
      this.getData();
    });
  }

  //保存分配数据
  distributePushSubmit() {
    this.$refs.PdDistributePushPatient.submit().then((res) => {
      this.showDistribute = false;
      this.getData();
    });
  }

  handleChangeTab(name: any) {
    this.selectedTab = name;
    this.getData();
  }

  async handleSetTeamSubmit() {
    let res = await this.$refs.SetTeam.submit();
    if (res) {
      this.showTeam = false;
      this.getData();
    }
  }

  async handleSetDoctorSubmit() {
    let res = await this.$refs.SetDoctor.submit();
    if (res) {
      this.showDoctor = false;
      this.getData();
    }
  }

  handleTownChanged() {
    if (this.cityList && this.cityList.length > 0) {
      this.villageList = this.cityList.filter(
        (x) => x.parentCode == this.queryCondition.addr_Town
      );
    }
  }

  // 新增患者
  handleAdd() {
    this.detailTitle = "";
    this.currentPatient = {};
    this.showPatientDetail = true;
  }

  //显示指标趋势图
  showChart(row: any) {
    this.chartData = {
      pD_Patient_ID: row.pD_Patient_ID,
      itemCode: row.itemCode,
      itemName: row.itemName,
      unit: row.unit,
    };
    this.showChartAssay = true;
  }

  //导出患者
  async handleExport() {
    if (this.selectedTab == "tabAll") {
      this.queryCondition.category = 0;
    } else {
      let user = this.$store.state.session.user;
      if (!user) {
        this.queryCondition.communityId = -1;
      } else {
        this.queryCondition.communityId = user.communityId;
      }
      if (this.selectedTab == "tabMyHos") {
        this.queryCondition.category = 1;
      } else if (this.selectedTab == "tabMyTeam") {
        this.queryCondition.category = 2;
      } else if (this.selectedTab == "tabMySelf") {
        this.queryCondition.category = 3;
      } else if (this.selectedTab == "tabAttention") {
        this.queryCondition.category = 4;
      }
    }
    if (this.queryCondition.communityId) {
      this.loading = true;
      let res = await ExportManagedPatients(this.queryCondition);
      this.loading = false;
      // 下载文件
      let baseUrl = `http://${location.hostname}:${SERVER_PORT}/`;
      let url = `${baseUrl}/${res.objects}`;
      let name = res.objects.split("/")[2];
      await this.download(url, name, {});
    }
  }

  async download(url: string, name: string, opts: any) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.onload = function () {
        FileSaver.saveAs(xhr.response, name, opts);
        resolve("success");
      };
      xhr.onerror = function () {
        console.error("could not download file");
        reject("failed");
      };
      xhr.send();
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/index.vue